export default {
  'discount-form:error:code-internal-usage-not-found': 'Invalid coupon code',
  'discount-form:error:code-expired': 'Invalid coupon code',
  'discount-form:error:code-exhausted-customer':
    'This coupon code can no longer be redeemed',
  'discount-form:error:code-not-applicable-to-customer':
    'You cannot redeem this code at the moment. Please contact customer service.',
  'discount-form:error:customer-fidelity-only-new-orders':
    'This coupon code is only valid for new customers.',
  'discount-form:error:customer-fidelity-only-old-customers':
    'This coupon code is only valid for existing customers.',
  'discount-form:error:basket-value-too-low':
    'Your cart is smaller than the minimum order value for this voucher',
};
